import type {EntityCustomFieldType} from 'nutshell-graphql-types';

import type {CreateCustomFieldState, CustomFieldEntity} from './types';

export function createCustomFieldReducer(
    state: CreateCustomFieldState,
    action: // Action to set the name of the custom field
    // Action to set the type of the custom field
    | {
              type: 'setName';
              name: string;
          } // Action to set the entity type of the custom field
        | {
              type: 'setType';
              customFieldType: EntityCustomFieldType;
          } // Action to update the full choices array for enum custom field
        | {
              type: 'setEntityName';
              entityName: CustomFieldEntity;
          } // Action to set if an enum custom field allows multiple selections
        | {
              type: 'updateChoices';
              choices: string[];
          } // Action to set the description of the custom field
        | {
              type: 'toggleAllowMultiple';
          }
        | {
              type: 'setDescription';
              description: string;
          }
): CreateCustomFieldState {
    switch (action.type) {
        case 'setName':
            return {...state, name: action.name};
        case 'setType':
            return {...state, type: action.customFieldType};
        case 'setEntityName':
            return {...state, entityName: action.entityName};
        case 'setDescription':
            return {...state, description: action.description};
        case 'updateChoices':
            return {...state, choices: action.choices};
        case 'toggleAllowMultiple':
            return {...state, allowMultiple: !state.allowMultiple};
        default:
            return state;
    }
}
